<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="tcp-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="courseDeleteDialogTitle"
      @click.self="onCancel"
    >
      <div class="tcp-modal-panel tcp-modal-panel--narrow">
        <div class="tcp-modal-header tcp-modal-header--with-icon">
          <div class="tcp-modal-icon--danger" aria-hidden="true">
            <i class="fas fa-trash-alt"></i>
          </div>
          <button
            type="button"
            class="tcp-modal-close"
            aria-label="Закрыть"
            :disabled="confirming"
            @click="onCancel"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <h5 id="courseDeleteDialogTitle" class="tcp-modal-title tcp-modal-title--spaced">{{ title }}</h5>
        <p class="tcp-modal-body">{{ bodyText }}</p>
        <p v-if="detail" class="tcp-modal-detail">{{ detail }}</p>
        <p v-if="errorMessage" class="tcp-modal-error" role="alert">
          <i class="fas fa-exclamation-circle me-2" aria-hidden="true"></i>{{ errorMessage }}
        </p>
        <div class="tcp-modal-footer">
          <button type="button" class="btn-cancel-modern" :disabled="confirming" @click="onCancel">
            Отмена
          </button>
          <button
            type="button"
            class="btn-danger-modern"
            data-testid="confirm-course-delete"
            :disabled="confirming"
            @click="$emit('confirm')"
          >
            <i v-if="confirming" class="fas fa-spinner fa-spin me-2"></i>
            <i v-else class="fas fa-trash-alt me-2"></i>
            Удалить
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import {
  COURSE_DELETE_CONFIRM_BODY,
  COURSE_DELETE_CONFIRM_TITLE,
} from '@/constants/userMessages';

export default {
  name: 'CourseDeleteConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    courseLabel: {
      type: String,
      default: '',
    },
    localization: {
      type: String,
      default: '',
    },
    confirming: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['confirm', 'cancel'],
  computed: {
    title() {
      return COURSE_DELETE_CONFIRM_TITLE;
    },
    bodyText() {
      const label = (this.courseLabel || 'курс').trim();
      return COURSE_DELETE_CONFIRM_BODY(label);
    },
    detail() {
      const loc = (this.localization || '').trim();
      return loc ? `Локализация: ${loc}` : '';
    },
  },
  methods: {
    onCancel() {
      if (this.confirming) return;
      this.$emit('cancel');
    },
  },
};
</script>
